import type { FormField } from '@/components/settings/hooks/types.ts';

export const fieldId = (field: FormField) => `onboarding-${field}`;
